// Publish panel → Infra canvas hand-off for custom domains.
//
// The "Custom domain" / "Find your domain" rows in Dropdown.Envs advertised
// the feature but had no handler — the legacy /add-domain + /add-cname modals
// they once pointed at are unrouted, and the second one never persisted
// anything. The REAL flow is the Infra canvas's connect-domain modal
// (infra/components/InfraDomainModal.js, driven by root.infra.domainFlow):
// check DNS → connect → status poll. This hands off to it — park the intent
// on the shell root, route to /infra, and `infraInit`
// (infra/functions/index.js) lifts it into root.infra.domainFlow on mount,
// pre-scoped to the project this canvas is editing.
//
// A root-state hand-off rather than a query string: both pages live in the
// one shell SPA (canvas's route map is merged into workspace's), and
// infraInit re-seeds root.infra WHOLESALE on every mount — anything written
// straight onto root.infra.domainFlow would be wiped before the modal reads
// it. `_infraIntent` follows the shell's underscore convention for transient
// root flags (_canvasSlot, _versionsOpen) and is consumed once.
//
// `this` is the calling element (`el.call('openProjectDomainFlow', opts)`).
// No module-scope helpers — the body must survive frank's per-function
// serialization with only `this` and its argument in reach.
export const openProjectDomainFlow = function (opts) {
  const options = opts && typeof opts === 'object' ? opts : {}
  const root = this.getRootState() || {}
  // Starter tier: the row shows the Upgrade link instead of the arrow, and a
  // click on the card lands on pricing — the same target as that link.
  if (root.tier === 'starter') {
    return this.call('openRouterModal', '/settings', { key: '/pricing' })
  }
  const projectId = String(
    options.projectId || root.projectId || (root.data && (root.data._id || root.data.id)) || ''
  )
  const step = options.step === 'new' ? 'new' : 'link'
  const envKey =
    typeof options.envKey === 'string' && options.envKey ? options.envKey : 'production'
  if (typeof root.update === 'function') {
    root.update({
      _infraIntent: {
        domainFlow: { step, phase: 'idle', host: '', projectId, envKey }
      }
    })
  }
  this.router('/infra', this.getRoot())
}
